import { render, staticRenderFns } from "./paIndexGroupManage.vue?vue&type=template&id=0802c59c&"
import script from "./paIndexGroupManage.vue?vue&type=script&lang=js&"
export * from "./paIndexGroupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports